import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { fadeInUp } from "@ntg/component-library/utilities";
import { motion } from "motion/react";
import { useLayoutContext } from "@ntg/component-library/contexts";

export default function Capabilities() {
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
    useEffect(() => {
        SetPrimaryTitle("SITE CAPABILITIES");
        SetSecondaryHeader(null);
        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
        };
    }, [SetPrimaryTitle, SetSecondaryHeader]);
    return (
        <motion.div {...fadeInUp}>
            <Box alignItems={"center"} display="flex" flexDirection="row" gap={7} justifyContent={"center"} p={2}>
                CONTENT TBA
            </Box>
        </motion.div>
    );
}
